<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.rolepermission') }} > {{ $t('sidebar.create') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <RolePermissionForm
        :appRolePermissions="appRolePermissions"
        :isSubmitted="isSubmitted"
        :disabled="disabled"
        :form.sync="form"
        @onSubmit="handleSubmit"
      />

      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'

export default {
  mixins: [discardFormMixin],

  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      form: null,
    }
  },

  computed: {
    ...mapState('appPermission', {
      appRolePermissions: 'permissionList',
    }),
  },

  created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.settings.title'),
      current: {
        app_name: 'settings',
        app_id: null,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 3,
      submenuAtIdx: 1,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('appPermission', {
      getAppPermissionList: 'getAppPermissionList',
    }),
    ...mapActions('rolePermission', {
      createRolePermission: 'createRolePermission',
    }),
    async fetchData () {
      this.loading = true
      await this.getAppPermissionList()
      this.loading = false
      this.showFinish(this.$Progress)
    },
    async handleSubmit (input = {}) {
      this.isSubmitted = true
      this.disabled = true
      const response = await this.createRolePermission({
        title: input.title,
        permissions: input.permissions,
      })
      if (response.success) {
        this.isSubmitted = false
        this.disabled = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: name }),
          color: 'success',
          icon: 'cloud',
        })
        this.$router.push({ name: 'SettingsRolePermissionList' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/settings/rolepermission/Create.vue